import request from '@/utils/request';

export async function getSysParam() {
  return request('/sysparams');
}

export async function changeSysParam(params, method) {
  return request('/sysparams', {
    method,
    body: {
      ...params,
    },
  });
}

export async function getLevel() {
  return request('/sysparams/securitylevel');
}

export async function getRule({ level }) {
  return request(`/sysparams/securityrules/${level}`);
}

export async function changeRule(params, method) {
  return request('/sysparams/securityrules', {
    method,
    body: {
      ...params,
    },
  });
}
